var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGuideLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 37.2H11V35H37V37.2Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7712 11.7156L31.1661 15.0107L31.1778 15.0222C31.6344 15.4788 31.8 16.0881 31.8 16.6125C31.8 17.1449 31.6327 17.72 31.259 18.1872C31.2326 18.2201 31.2045 18.2515 31.1745 18.2811L19.3745 29.9811C19.2214 30.1329 19.0271 30.2364 18.8158 30.2787L14.337 31.1744C13.5084 31.3694 12.7385 31.0441 12.2472 30.5528C11.7559 30.0616 11.4306 29.2917 11.6256 28.463L12.5214 23.9843C12.564 23.7713 12.6686 23.5758 12.8222 23.4222L24.5222 11.7222C24.9585 11.2859 25.5312 11.025 26.15 11.025C26.7657 11.025 27.3358 11.2833 27.7712 11.7156ZM26.1449 13.2276C26.1357 13.2315 26.1117 13.244 26.0778 13.2778L14.6133 24.7423L13.7787 28.9158C13.7762 28.9279 13.7736 28.94 13.7708 28.952C13.7749 28.9618 13.7846 28.9789 13.8028 28.9972C13.8211 29.0155 13.8382 29.0251 13.848 29.0293C13.8601 29.0264 13.8722 29.0238 13.8843 29.0214L18.0602 28.1862L29.5595 16.7843C29.5666 16.7713 29.5739 16.7549 29.5804 16.7351C29.5932 16.6962 29.6 16.6533 29.6 16.6125C29.6 16.5848 29.5969 16.5639 29.5939 16.5505L26.2339 13.2894L26.2222 13.2778C26.1884 13.244 26.1643 13.2315 26.1552 13.2276C26.153 13.2266 26.1513 13.226 26.15 13.2255C26.1488 13.226 26.1471 13.2266 26.1449 13.2276Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26.2,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGuideLight);
export default __webpack_public_path__ + "static/media/icon_guide_light.05599d9b.svg";
export { ForwardRef as ReactComponent };